import { Component } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { EmailInvite } from '@/model/Sheet';
import ToastVariant from '@/model/enums/toast/toast-variant';
import ToastMixin from '@/mixins/ToastMixin';

@Component({
    methods: {
        ...mapActions({
            invite: 'sheetStorage/invite',
        }),
    },
})
export default class SheetInviteMixin extends ToastMixin {
    invite!: (emailInvite: EmailInvite) => Promise<void>;

    inviteLoading = false;

    submitSheetInvite(
        email: string,
        sheetId: number | undefined,
        successMessageKey: string,
        successTitleKey: string,
    ): void {
        if (!sheetId || this.inviteLoading) {
            return;
        }

        this.inviteLoading = true;
        this.invite({ email, sheetId })
            .then(() => {
                this.$bvModal.hide('invite-modal');
                this.showToast(
                    this.$t(successMessageKey).toString(),
                    this.$t(successTitleKey).toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => undefined)
            .finally(() => {
                this.inviteLoading = false;
            });
    }
}
